// extracted by mini-css-extract-plugin
export default {"image":"fileuploadStyles_image__o+L5r","card":"fileuploadStyles_card__EdsBm","button":"fileuploadStyles_button__Nj0p9","text":"fileuploadStyles_text__g8piM"};